import { HttpClient, HttpEventType, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-auto-upload-dialog',
    templateUrl: './auto-upload-dialog.component.html',
    styleUrls: ['./auto-upload-dialog.component.scss'],
})
export class AutoUploadDialogComponent implements OnInit {
    @ViewChild('fileSelector') fileSelector;

    filesToUpload: File[] = [];
    filesProgressValues: number[] = [];
    filesUploadStatus: number[] = [];
    showCloseButton: boolean = false;
    showUploadAndSelector: boolean = true;

    apiUrl: string;
    nameOfIdField: string;
    id: number;

    constructor(
        public dialogRef: MatDialogRef<AutoUploadDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private http: HttpClient,
        private messageService: MessageService,
    ) {
        this.apiUrl = data.apiUrl;
    }

    ngOnInit() {}

    openFileSelector() {
        this.fileSelector?.nativeElement?.click();
    }

    handleFiles(event: any) {
        let files = event.target.files;
        for (var i = 0; i < files.length; i++) {
            this.filesToUpload.push(files.item(i));
            this.filesProgressValues[i] = 0;
        }
    }

    uploadFilesToServer() {
        if (this.filesToUpload.length > 0) {
            for (var i = 0; i < this.filesToUpload.length; i++) {
                let fileNumber = i;
                let file = this.filesToUpload[fileNumber];

                let fd = new FormData();
                fd.append('dokument', file);

                let params = new HttpParams();

                const options = {
                    headers: new HttpHeaders('Phito-Type: fileupload'),
                    params: params,
                    reportProgress: true,
                };

                // const request = new HttpRequest('POST', this.apiBaseUrl + this.apiUrl, fd, options);
                this.http.post<any>(this.apiBaseUrl + this.apiUrl, fd, options).subscribe(
                    event => {
                        if (event.type == HttpEventType.UploadProgress) {
                            let percentDone = Math.round((100 * event.loaded) / event.total);
                            this.filesProgressValues[fileNumber] = percentDone;
                            console.debug('Uploaded ' + percentDone + '% of file ' + file.name);
                        } else if (event instanceof HttpResponse) {
                            console.debug('Uploaded file ' + file.name + ' completely!');
                        }
                    },
                    error => {
                        console.error('Error while uploading file: ' + file.name);
                        this.filesUploadStatus[fileNumber] = 2;
                        this.messageService.errorMessage('Fehler', error);
                        this.markFileAsFailed(fileNumber);
                    },
                    () => {
                        this.markFileAsUploaded(fileNumber);
                        console.debug('Upload of file ' + file.name + ' done!');
                        this.messageService.infoMessage(file.name + ' erfolgreich hochgeladen!');
                    },
                );
            }
        } else {
            this.messageService.errorMessage('Keine Dateien zum Upload ausgewählt', null);
        }
    }

    markFileAsFailed(no: number) {
        console.debug('markFileAsFailed: ' + no);
        this.filesUploadStatus[no] = 2;
        this.checkShowCloseButton();
    }

    markFileAsUploaded(no: number) {
        console.debug('markFileAsUploaded: ' + no);
        this.filesUploadStatus[no] = 1;
        this.checkShowCloseButton();
    }

    checkShowCloseButton() {
        var show: boolean = true;
        for (var i = 0; i < this.filesUploadStatus.length; i++) {
            if (this.filesUploadStatus[i] == 0) {
                show = false;
            }
        }
        if (show == true) {
            this.showCloseButton = true;
        }
    }

    uploadFiles() {
        this.showUploadAndSelector = false;
        this.uploadFilesToServer();
    }

    closeDialog() {
        this.dialogRef.close(true);
    }

    onCancelClick(): void {
        this.dialogRef.close(false);
    }
}
